import common from '@/sui/data/sheets/convert/common'
import fields from '@/sui/data/sheets/edit/fields'

const neoInfCatheters = (function () {
  const all = [
    { field: fields.material },
    { field: fields.insertion, special: 'date' },
    { field: fields.insertionSite },
    { field: fields.ventilation },
    { field: fields.lipids },
    { field: fields.removed },
    { field: fields.removal, special: 'date' },
    { field: fields.removalReason },
    { field: fields.laboratory },
    { field: fields.isColIlcBlcSep },
    { field: fields.colIlcBlcSep, special: 'date' },
    { field: fields.colIlcBlcSepOrigin },
    { field: fields.lipidsDiagnosis }
  ]

  const v1 = [
    { field: fields.catheterType },
    common.specialMicroOrgs.noVirus.v1,
    { field: fields.blcCriteria }
  ]

  const v2 = [
    common.addV2(fields.catheterType),
    common.specialMicroOrgs.noVirus.v1,
    { field: fields.diagDate, special: 'date' },
    { field: fields.covidStatus },
    { field: fields.blcCriteria }
  ]

  const v3 = [
    common.addV2(fields.catheterType),
    common.specialMicroOrgs.noVirus.v1,
    { field: fields.diagDate, special: 'date' },
    { field: fields.covidStatus },
    { field: fields.divDiag },
    { field: fields.clinicalSigns },
    { field: fields.bioSigns },
    { field: fields.adaptedAntibio },
    { field: fields.twoHemocs }
  ]

  const v4 = [
    common.addV2(fields.catheterType),
    common.specialMicroOrgs.noVirus.v2,
    { field: fields.diagDate, special: 'date' },
    { field: fields.covidStatus },
    { field: fields.divDiag },
    { field: fields.clinicalSigns },
    { field: fields.bioSigns },
    { field: fields.adaptedAntibio },
    { field: fields.twoHemocs }
  ]

  const v5 = [
    common.addV2(fields.catheterType),
    common.specialMicroOrgs.noVirus.v3,
    { field: fields.diagDate, special: 'date' },
    { field: fields.covidStatus },
    { field: fields.divDiag },
    { field: fields.clinicalSigns },
    { field: fields.bioSigns },
    { field: fields.adaptedAntibio },
    { field: fields.twoHemocs }
  ]

  return {
    v1: [...v1, ...all],
    v2: [...v2, ...all],
    v3: [...v3, ...all],
    v4: [...v4, ...all],
    v5: [...v5, ...all]
  }
})()

const neoInfSepsis = (function () {
  const all = [
    { field: fields.present },
    { field: fields.episod, special: 'date' },
    { field: fields.origin }
  ]

  const v1 = [
    { field: fields.entrance }
  ]

  const v2 = [
    { field: fields.diagDate, special: 'date' },
    common.addV2(fields.entrance),
    { field: fields.covidStatus }
  ]

  const v3 = [
    { field: fields.lipids }
  ]

  return {
    v1: [
      ...all,
      ...v1
    ],

    v2: [
      ...all,
      ...v2
    ],

    v3: [
      ...all,
      ...v2,
      ...v3
    ]
  }
})()

function build (v) {
  const list = [
    { field: fields.sheetNumber, special: 'numeric' },
    { field: fields.uf },
    { field: fields.unitType, special: 'unitType' },
    { field: fields.birthdate, special: 'date' },
    { field: fields.sex },
    { field: fields.entrydate, special: 'date' },
    { field: fields.birthSite },
    { field: fields.origin },
    { field: fields.mainSeverity, special: 'mainSeverity' },
    { field: fields.otherSeverity, special: 'otherSeverity' },
    { field: fields.birthWeight, special: 'numeric' },
    { field: fields.gestationalAge, special: 'numeric' },
    { field: fields.leucomalacy },
    { field: fields.dead },
    { field: fields.death, special: 'date' },
    { field: fields.exit, special: 'date' },
    { field: fields.future }
  ]

  if (v === 1) {
    list.push(
      { field: fields.catheterArray, array: neoInfCatheters.v1 },
      { field: fields.sepsis, array: neoInfSepsis.v1 },
      { field: fields.bactArray, array: common.bacteremia.v1 }
    )
  } else if (v === 2) {
    list.push(
      { field: fields.catheterArray, array: neoInfCatheters.v2 },
      { field: fields.sepsis, array: neoInfSepsis.v2 },
      { field: fields.bactArray, array: common.bacteremia.v2 }
    )
  } else if (v === 3) {
    list.push(
      { field: fields.catheterArray, array: neoInfCatheters.v3 },
      { field: fields.sepsis, array: neoInfSepsis.v2 },
      { field: fields.bactArray, array: common.bacteremia.v3 },
      { field: fields.covidStatus }
    )
  } else if (v === 4) {
    list.push(
      { field: fields.catheterArray, array: neoInfCatheters.v3 },
      { field: fields.sepsis, array: neoInfSepsis.v3 },
      { field: fields.bactArray, array: common.bacteremia.v3 },
      { field: fields.covidStatus }
    )
  } else if (v === 5) {
    list.push(
      { field: fields.catheterArray, array: neoInfCatheters.v4 },
      { field: fields.sepsis, array: neoInfSepsis.v3 },
      { field: fields.bactArray, array: common.bacteremia.v4 },
      { field: fields.covidStatus }
    )
  } else {
    list.push(
      { field: fields.catheterArray, array: neoInfCatheters.v5 },
      { field: fields.sepsis, array: neoInfSepsis.v3 },
      { field: fields.bactArray, array: common.bacteremia.v6 },
      { field: fields.covidStatus }
    )
  }

  return list
}

export default {
  '2019': build(1),
  '2020': build(2),
  '2021': build(3),
  '2022': build(4),
  '2023': build(5),
  '2024': build(5),
  '2025': build(6),
  '2026': build(6)
}
